import React from 'react';

export const ButtonCancel = ({ buttonCancelAction, buttonCancelHidden, buttonCancelText, showModalCancel }) => {
    const buttonClass = buttonCancelHidden ? 'hidden' : 'form__button roadmap-navigation__button-cancel';
    const handleClick = buttonCancelAction ?? showModalCancel;

    return (
        <button className={buttonClass} type="button" onClick={handleClick}>
            {buttonCancelText}
        </button>
    );
};
